import styled from 'styled-components';
import { AuctionDateContainer } from '../AuctionDate/AuctionDate';

export const UpcomingAuctionContainer = styled.div`
  margin-bottom: 50px;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${(props) => props.theme.phone} {
    margin-bottom: 0;
  }

  ${AuctionDateContainer} {
    justify-content: center;
    margin-bottom: 10px;
    font-size: 1.6rem;
  }
`;
